<template>
	<el-tabs id="userinfoList" value="first" type="border-card">
		<el-tab-pane name="first" :label="$t('taskInfo')">
			<el-row>
				<el-col :xs="24">
          <el-form :model="taskForm" :rules="rules" ref="taskForm" label-width="200px">
					  <el-card >
              <el-row>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectName1')" prop="projectName">
                    <el-input v-model="taskForm.projectName" v-if="editDis == 1" disabled/>
                    <el-input v-model="taskForm.projectName" v-if="editDis == 0" @click.native="selectProject"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('projectType1')" >
										<el-input v-model="taskForm.projectType" disabled/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskType1')" prop="taskType">
                    <el-select v-model="taskForm.taskType" clearable @change="selectTaskType">
											<el-option v-for="item in TaskTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskName1')" prop="taskName">
										<el-input v-model="taskForm.taskName" :disabled="!taskCanEdit" :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12" >
									<el-form-item :label="$t('serviceBom1')" prop="serviceBom">
                    <el-select v-model="taskForm.serviceBom" clearable filterable remote :remote-method="remoteBom" v-el-select-loadmore="loadMore(rangeNumber)" v-bind:disabled="serviceBomDisabled">
                      <el-option v-for="(item, index) in ServiceBomList.slice(0, rangeNumber)" :key="index" :label="item.serviceBom" :value="item.serviceBom"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('bomDescription1')" >
                    <el-input v-model="taskForm.bomDescription" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskOwner1')" prop="taskOwner">
                    <el-select v-model="taskForm.taskOwner" clearable filterable remote :remote-method="remoteMethod">
                      <el-option v-for="(item, index) in TaskOwnerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
                    </el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskStatus1')" prop="taskStatus" >
                    <el-select v-model="taskForm.taskStatus" clearable>
											<el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('financialAttributes1')" prop="financialAttributes">
                    <el-select filterable v-model="taskForm.financialAttributes" disabled>
											<el-option v-for="item in FinancialAttributesList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('planLabourHour1')" >
										<el-input v-model="taskForm.planLabourHour" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationMethod1')" >
                    <el-select filterable v-model="taskForm.revenueConfirmationMethod" clearable>
											<el-option v-for="item in RevenueConfirmationMethodList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskSubcontract1')" prop="subcontract">
                    <el-select filterable v-model="taskForm.subcontract" clearable>
											<el-option v-for="item in SubcontractList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<!-- <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('hardwareProductLine1')" prop="hardwareProductLine">
										<el-select filterable v-model="taskForm.hardwareProductLine" clearable>
											<el-option v-for="item in HardwareProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
								<el-col :xs="24" :md="12">
									<el-form-item :label="$t('serviceProductLine1')" prop="serviceProductLine">
                    <el-select filterable v-model="taskForm.serviceProductLine" clearable>
											<el-option v-for="item in ServiceProductLineList" :key="item.value" :label="item.label" :value="item.value"></el-option>
										</el-select>
									</el-form-item>
								</el-col>
							</el-row> -->
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskStartDate1')" prop="taskStartDate">
										<el-date-picker v-model="taskForm.taskStartDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskEndDate1')" prop="taskEndDate">
										<el-date-picker v-model="taskForm.taskEndDate" disabled type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
              </el-row>
							<el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryArea1')" prop="deliveryArea">
                    <el-input v-model="taskForm.deliveryArea" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskAmountWithTax1')" >
                    <el-input v-model="taskForm.amountWithTax" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <!-- <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryLabourHour1')" prop="deliveryLabourHour">
                    <el-input v-model="taskForm.deliveryLabourHour" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col> -->
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationAmount1')" >
										<el-input v-model="taskForm.revenueConfirmationAmount" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('revenueConfirmationStatus1')">
										<el-input v-model="taskForm.revenueConfirmationStatus" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
							<!-- <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('deliveryFinishDate1')" prop="deliveryFinishDate"  >
                    <el-date-picker v-model="taskForm.deliveryFinishDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" 
                      :placeholder="$t('selectdate')"></el-date-picker>
									</el-form-item>
								</el-col>
							</el-row> -->
              <el-row>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('subcontractNo1')" >
                    <el-input v-model="taskForm.subcontractNo" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
                <el-col :xs="24" :md="12">
									<el-form-item :label="$t('taskSubcontractor1')" >
                    <el-input v-model="taskForm.subcontractor" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
							</el-row>
              <el-row>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('taskReport1')"  >
                    <el-upload action="" :accept="acceptFileType" :before-upload="beforeUpload" 
                      :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :auto-upload="true" >
                      <el-button slot="trigger" size="small" type="primary">{{$t('upload')}}</el-button>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item :label="$t('serviceDuration1')" >
										<el-input v-model="taskForm.serviceDuration" clearable :placeholder="$t('enter')"/>
									</el-form-item>
								</el-col>
              </el-row>
              <el-row>
                <el-col style="margin-top: 10px; text-align: center;" :xs="24" :md="24">
                  <el-button type="primary" @click="submitForm('taskForm')">{{$t('save')}}</el-button>
                  <el-button type="primary" size="medium" @click="returnList">{{$t('return')}}</el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
          <Modal v-model="modelSearch" width="60%" id="modelSearch" :closable='true' :mask-closable='false' :title="$t('Select Project')">
            <div slot="footer"></div>
            <!-- 查询选项 -->
            <Form class="modelForm" :label-width="160">
              <FormItem class="modelItem" :label="$t('projectName1')">
                <Input clearable v-model="pjName" :placeholder="$t('enter')"/>
              </FormItem>
              <FormItem class="modelItem" :label="$t('projectStartDate1')" >
                <el-date-picker v-model="pjSDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
              </FormItem>
              <FormItem class="modelItem" :label="$t('projectEndDate1')" >
                <el-date-picker v-model="pjEDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
              </FormItem>
              <FormItem class="modelItem" :label="$t('projectType1')">
                <el-select v-model="pjType" clearable>
                  <el-option v-for="item in ProjectTypeList" :key="item.sysDesc" :label="item.sysValue" :value="item.sysDesc">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem class="modelItem" :label="$t('country1')">
                <el-select v-model="pjcountry" clearable filterable>
                  <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
                </el-select>
              </FormItem>
              <FormItem class="modelItem" :label="$t('customerName1')">
                <Input v-model="pjcustomerName" clearable :placeholder="$t('enter')"/>
              </FormItem>
              <div class="buttonDiv">
                <el-button type="primary" size="mini" icon="el-icon-search" @click="searchProjectList">{{$t('search')}}</el-button>
              </div>
            </Form>
            <el-table :data="PJList" border style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
              <el-table-column prop="projectName" :label="$t('projectName')" align="center" min-width="210" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                <a style="color:blue;" @click="handleInfo(scope.row)">{{scope.row.projectName}}</a>
              </template>
              </el-table-column>
              <el-table-column prop="projectStartDate" :label="$t('projectStartDate')" align="center" min-width="155" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="projectEndDate" :label="$t('projectEndDate')" align="center" min-width="155" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="projectType" :label="$t('projectType')" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="customerName" :label="$t('customerName')" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="country" :label="$t('country')" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
            <div class="pageDiv">
              <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[5,10,30,50]"
                :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
              </el-pagination>
            </div>
          </Modal>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'
    export default {
        created () {
          this.getProjectTypeList();
          this.getCountry();
          this.getProjectList();
          this.getServiceBomList();
        },
        data () {
          var changeBom = (rule, value, callback) => {
            let businessCategory = this.businessCategory;
            if(value == null || value == ""){
              if(businessCategory == 'CD'){
                return callback(new Error("Please select bom"));
              }
            }else{
              let bomInfo = this.ServiceBomList.find(item => {
                return item.serviceBom === value;
              })
              if(bomInfo != null){
                let bomdesc = bomInfo.bomEnDescribe==null?bomInfo.serviceDescribe:bomInfo.bomEnDescribe;
                this.taskForm.bomDescription = bomdesc;
              }
              if(businessCategory == 'CD'){
                let taskType = this.taskForm.taskType;
                if(taskType != null && taskType != ""){
                  let taskTypeInfo = this.TaskTypeList.find(item => {
                    return item.sysDesc === taskType;
                  })
                  if(taskTypeInfo != null){
                    this.taskForm.taskName = this.taskForm.projectName + "--" + taskTypeInfo.sysValue + "--" + value;
                  }
                }
              }
            }
            callback();
          };
          var checkDate = (rule, value, callback) => {
            if(this.taskForm.taskStartDate != null && this.taskForm.taskEndDate !=  null){
              if(this.taskForm.taskStartDate >= this.taskForm.taskEndDate ){
                return callback(new Error('The end date must be later than start date'));
              }else if(this.taskForm.taskEndDate > this.pjEndDate){
                return callback(new Error('The task end date must be earlier than project end date'));
              }
            }
            callback();
          };
          var checkFinishDate  = (rule, value, callback) => {
            if(this.taskForm.taskStartDate != null){
              if(this.taskForm.taskStartDate >= value ){
                return callback(new Error('The finish date must be later than start date'));
              }
            }
            callback();
          };
          var checkHours = (rule, value, callback) => {
            if(value != null && value != ""){
              let reg = /^\d+(\.\d{0,2})?$/;
              if(!reg.test(value)){
                return callback(new Error('Please enter integer or decimal to two places'));
              }else if(value < 0.01 || value > 9999){
                return callback(new Error('Please enter 0.01--9999.00'));
              }
            }
            callback();
          };
          return {
            rangeNumber: 10,
            taskForm: {
              projectType:null,
              projectId:null,
              projectName:null,
              taskName:null,
              taskOwner:null,
              taskStatus:null,
              taskType:null,
              serviceBom:null,
              bomDescription:null,
              financialAttributes:null,
              subcontract:null,
              subcontractor:null,
              revenueConfirmationMethod:null,
              hardwareProductLine:null,
              serviceProductLine:null,
              serviceDuration:null,
              taskStartDate:null,
              taskEndDate:null,
              deliveryArea:null,
              deliveryLabourHour:null,
              revenueConfirmationAmount:null,
              revenueConfirmationStatus:null,
              amountWithTax:null,
              deliveryFinishDate:null,
              remasubcontractNork:null,
              taskReport:null,
              planLabourHour:null,
            },
            serviceBomDisabled:false,
            editDis:0,
            pjEndDate:null,
            reportArr:[],
            fileList:[],
            acceptFileType:'.bpm,.gif,.jpg,.jpeg,.png,.pdf,.xls,.xlsx,.doc,.docx',
            businessCategory:null,
            TaskOwnerList:[],
            ServiceBomList:[],
            SBomList:[],
            PJList:[],
            projects:[],
            CountryList:[],
            pjName:null,
            pjSDate:null,
            pjEDate:null,
            pjType:null,
            pjcountry:null,
            pjcustomerName:null,
            modelSearch:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 5,
            ProjectTypeList:[],
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
            ],
            TaskTypeList:[],
            FinancialAttributesList:[
              { value: 'Warranty',label: 'Warranty'},
              { value: 'ServiceCost',label: 'Service Cost'},
              { value: 'ExchangeFee',label: 'Market Support Expense'},
              { value: 'PlatformFee',label: 'Platform Expense'},
              { value: 'MarketingFee',label: 'Service Marketing Expense'},
            ],
            RevenueConfirmationMethodList:[
              { value: 'PS-CTC',label: 'PS-CTC'},
              { value: 'PS-COM',label: 'PS-COM'},
              { value: 'PS-PER',label: 'PS-PER'},
              { value: 'PS-NRA',label: 'PS-NRA'},
            ],
            SubcontractList:[
              { value: 'Yes',label: 'Yes'},
              { value: 'No',label: 'No'},
            ],
            HardwareProductLineList:[
              { value: '1',label: '待定'},
            ],
            ServiceProductLineList:[
              { value: '1',label: '待定'},
            ],
            rules: {
              projectName: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskName: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              taskStatus: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskOwner: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskType: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              serviceContent: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              serviceBom: [
                { validator:changeBom, trigger: 'change' }
              ],
              bomDescription: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              financialAttributes: [
                { required: true, message:'Please select data', trigger: 'change' },
              ],
              taskStartDate: [
                { required: true, message:'Please select date', trigger: 'change' },
                { validator: checkDate, trigger: 'change'}
              ],
              taskEndDate: [
                { required: true, message:'Please select date', trigger: 'change' },
                { validator: checkDate, trigger: 'change'}
              ],
              deliveryArea: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              deliveryLabourHour: [
                { validator: checkHours, trigger: 'blur' }
              ],
              deliveryFinishDate: [
                { validator: checkFinishDate, trigger: 'change'}
              ],
              subcontract: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
            },
            taskCanEdit:false,
          }
        },
        methods:{
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getProjectTypeList(){
            let url = `${this.$store.state.islhurl}keyValue/getSelectData`
            let pm = {
              sysKey: 'ProjectType',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res =>{
                this.ProjectTypeList = res.data;
              }
            )
          },
          getServiceBomList(){
            let url =`${this.$store.state.islhurl}serviceBom/getSelectData`;
            this._post(url).then(
              res => {   
                this.SBomList = res.data;
                this.ServiceBomList = res.data;
              }
            )
          },
          getProjectList(){
            let pm = {};
            let url =`${this.$store.state.islhurl}project/getUserProjectList/${this.pageSize}/${this.currentPage}`;
            let pjNumber = this.$route.params.projectNumber;
            if(pjNumber != undefined && pjNumber != null && pjNumber != ''){
              pm = {
                projectNumber: pjNumber,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }else{
              pm = {
                projectName: this.pjName==''?null:this.pjName,
                projectStartDate: this.pjSDate==''?null:this.pjSDate,
                projectEndDate: this.pjEDate==''?null:this.pjEDate,
                projectType: this.pjType==''?null:this.pjType,
                country: this.pjcountry==''?null:this.pjcountry,
                customerName: this.pjcustomerName==''?null:this.pjcustomerName,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
            }
            this._post(url,pm).then(
              res => {   
                this.PJList = res.data;
                this.projects = res.data;
                this.totalCount = res.totalNums;
                let pjNumber = this.$route.params.projectNumber;
                if(pjNumber != undefined && pjNumber != null && pjNumber != ''){
                  this.taskForm.projectId = pjNumber;
                  this.selectProjectName(pjNumber);
                  this.editDis = 1;
                }
                if(this.pjName!==''&&res.data[0].taskCanEdit === false ){
                  this.taskCanEdit = false
                }else{
                  this.taskCanEdit = true
                }
              }
            )
          },
          searchProjectList(){
            this.pageSize = 5;
            this.currentPage = 1;
            let url =`${this.$store.state.islhurl}project/getUserProjectList/${this.pageSize}/${this.currentPage}`;
            let pm = {
              projectName: this.pjName==''?null:this.pjName,
              projectStartDate: this.pjSDate==''?null:this.pjSDate,
              projectEndDate: this.pjEDate==''?null:this.pjEDate,
              projectType: this.pjType==''?null:this.pjType,
              country: this.pjcountry==''?null:this.pjcountry,
              customerName: this.pjcustomerName==''?null:this.pjcustomerName,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {   
                this.PJList = res.data;
                this.totalCount = res.totalNums;
                if(this.pjName!==''&&res.data[0].taskCanEdit === false ){
                  this.taskCanEdit = false
                }else{
                  this.taskCanEdit = true
                }
              }
            )
          },
          selectProject(){
            this.pjName = null;
            this.pjSDate = null;
            this.pjEDate = null;
            this.pjType = null;
            this.pjcountry = null;
            this.pjcustomerName = null;
            this.PJList = this.projects;
            this.modelSearch = true;
          },
          handleInfo(item){
            this.taskForm.projectId = item.projectNumber;
            this.selectProjectName(item.projectNumber);
            this.modelSearch = false;
          },
          selectProjectName(projectId){
            let projectInfo = this.PJList.find(item => {
              return item.projectNumber === projectId;
            })
            if(projectInfo != null){
              this.businessCategory = projectInfo.businessCategory;
              this.taskForm.projectName = projectInfo.projectName;
              this.taskForm.projectType = projectInfo.projectType;
              this.taskForm.taskStartDate = projectInfo.projectStartDate;
              this.taskForm.taskEndDate = projectInfo.projectEndDate;
              this.pjEndDate = projectInfo.projectEndDate;
              this.taskCanEdit = projectInfo.taskCanEdit
              let pTypes = this.ProjectTypeList.find(item => {
                return item.sysValue === projectInfo.projectType;
              })
              //通过项目类型查询任务类型
              let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
              let pm = {
                sysKey: 'TaskType',
                remark: pTypes.sysDesc,
              }
              this._post(url,pm).then(
                res => {
                  this.TaskTypeList = res.data;
                  if(pTypes.sysDesc == 'MSS' || pTypes.sysDesc == 'MSC' || pTypes.sysDesc == 'SSS' || pTypes.sysDesc == 'GWP'){
                    //通过项目类型查询已创建任务类型
                    let url =`${this.$store.state.islhurl}task/getCreatedTask`;
                    let pm = {
                      projectId: projectId,
                    }
                    this._post(url,pm).then(
                      res => {
                        if(res.tasks.length > 0){
                          res.tasks.forEach((va, ind) => {
                            this.TaskTypeList.forEach((vr, idx) => {
                              if(va == vr.sysDesc){
                                this.TaskTypeList.splice(idx, 1);
                              }
                            })
                          })
                        }
                      }
                    )
                  }
                }
              );
              if(projectInfo.businessCategory == 'MS'){
                this.taskForm.financialAttributes = 'ExchangeFee';
              }else if(projectInfo.businessCategory == 'CD'){
                this.taskForm.financialAttributes = 'ServiceCost';
              }else if(projectInfo.businessCategory == 'WD'){
                this.taskForm.financialAttributes = 'Warranty';
              }else if(projectInfo.businessCategory == 'SS' || projectInfo.businessCategory == 'SD'){
                this.taskForm.financialAttributes = 'MarketingFee';
              }else if(projectInfo.businessCategory == 'GW'){
                this.taskForm.financialAttributes = 'PlatformFee';
              }
            }
          },
          selectTaskType(taskType){
            let taskTypeInfo = this.TaskTypeList.find(item => {
              return item.sysDesc === taskType;
            })
            if(taskTypeInfo != null){
              this.taskForm.taskName = this.taskForm.projectName + "--" + taskTypeInfo.sysValue;
            }
          },
          changeBom(serviceBom){
            let bomInfo = this.ServiceBomList.find(item => {
              return item.serviceBom === serviceBom;
            })
            let bomdesc = bomInfo.bomEnDescribe==null?bomInfo.serviceDescribe:bomInfo.bomEnDescribe;
            this.taskForm.bomDescription = bomdesc;
          },
          submitForm(formName) {
            this.$refs[formName].validate((pvalid) => {
              if (pvalid) {
                console.log('success submit')
                this.addInfo();
              } else {
                console.log('error submit!!');
                return false;
              } 
            });
          },
          addInfo(){
            if(this.reportArr != null && this.reportArr.length > 0){
              let attachmentArr = [];
              this.reportArr.forEach(item => {
                attachmentArr.push(item.aid);
              });
              this.taskForm.taskReport = attachmentArr.join(",");
            }
            let params = {
              task:this.taskForm,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(params);
            let url = `${this.$store.state.islhurl}task/addInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  let pm = {toTask: 'N'}
                  this.$router.push({name:'task',params:pm});
                  // this.$router.push({path:'/task/list'})
                  this.$Message.success('Save successful' )
                }else{
                  this.$message({type:'error', showClose:true, duration:10000, message:res});
                }
              }
            )
          },
          beforeUpload(file){
            this.downloadLoading = this.$loading({
              lock:true,
              text:'Data is importing...',
              spinner:'el-icon-loading',
              background:'rgba(0,0,0,0.7)'
            });
            let fd = new FormData();
            fd.append('fileInput',file);
            fd.append('source',"Task");
            fd.append('islhToken',sessionStorage.getItem("islhtoken"));
            let url = `${this.$store.state.islhurl}upload`
            this._post(url,fd).then(
              res =>{
                this.downloadLoading.close();
                if(res.code == '200'){
                  this.fileList.push({name: res.fileName, url: res.fileAliasName});
                  this.reportArr.push({aid: res.attachmentId, fileurl: res.fileAliasName});
                  this.$message.success('File import successful！');
                }else{
                  this.$message({type:'error', showClose:true, duration:10000, message:res});
                }
              }
            ).catch(error=> {
              this.downloadLoading.close();
              this.$message({type:'error', showClose:true, duration:10000, message:'Operation failed！error:'+error});
            })
          },
          handlePreview(file){
            let url =`${this.$store.state.islhurl}download?fileAliasName=${file.url}&fileName=${file.name}`
            window.open(url);
          },
          handleRemove(file){
            if (file && file.status === "success") {
              let attachmentId = null;
              this.reportArr.forEach(item => {
                if (item.fileurl === file.url) {
                  attachmentId = item.aid;
                  this.reportArr.splice(item, 1);
                }
              });
              let params = {
                id: attachmentId,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              let url =`${this.$store.state.islhurl}attachment/deleteInfo`;
              this._post(url, params).then(
                res => {
                  this.fileList.forEach(item => {
                    if (item.url === file.url) {
                      this.fileList.splice(item, 1);
                    }
                  });
                }
              )
            }
          },
          changePage (val) {
            this.currentPage = val;
            this.getProjectList();
          },
          changePageSize (val) {
            this.pageSize = val;
            this.getProjectList();
          },
          returnList(){
            this.$router.push({path:'/task/list'})
          },
          loadMore(n) {
            // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
            // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
            return () => (this.rangeNumber += 5); // 每次滚动到底部可以新增条数,可自定义
          },
          //远程搜索方法
          remoteMethod(query) {
            if (query !== '') {
              // 清除之前的定时器
              if (this.timeout) {
                clearTimeout(this.timeout)
              }
              // 防抖处理，300ms后执行
              this.timeout = setTimeout(() => {
                this.fetchUserOptions(query)
              }, 200)
            } else {
              this.TaskOwnerList = [];
            }
          },
          fetchUserOptions(query) {
            let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
            this._get(url).then().then(res => {
              if(res.code === 200 && res.data) {
                this.TaskOwnerList = res.data;
              } else {
                this.TaskOwnerList = [];
              }
            }).catch(error => {
              this.TaskOwnerList = [];
              console.error('搜索失败:', error)
            })
          },
          remoteBom(query) {
            if (query !== '') {
              setTimeout(() => {
                this.ServiceBomList = this.SBomList.filter(item => {
                  return item.serviceBom.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
              }, 200);
            } else {
              this.ServiceBomList = this.SBomList;
            }
          },
        },
        watch:{
          'taskForm.subcontract'(val,oldval){
            if(this.taskForm.subcontract=='Yes' && (this.taskForm.taskType=='CUSSC' || this.taskForm.taskType=='POCSC')){
              this.taskForm.serviceBom='8814A0Q7';
              this.serviceBomDisabled=true;
            }else if(this.taskForm.subcontract=='Yes' && this.taskForm.taskType=='WDCSC'){
              this.taskForm.serviceBom='8813A4GP';
              this.serviceBomDisabled=true;
            }else{
              this.serviceBomDisabled=false;
            }
          },
          'taskForm.taskType'(val,oldval){
            if(this.taskForm.taskType=='CUSSC' || this.taskForm.taskType=='POCSC'){
              this.taskForm.serviceBom='8814A0Q7';
              this.serviceBomDisabled=true;
              this.taskForm.subcontract="Yes";
            }else if(this.taskForm.taskType=='WDCSC'){
              this.taskForm.serviceBom='8813A4GP';
              this.serviceBomDisabled=true;
              this.taskForm.subcontract="Yes";
            }else{
              this.serviceBomDisabled=false;
              this.taskForm.serviceBom="";
              this.taskForm.subcontract="No";
            }
          }
        },
        directives:{
          'el-select-loadmore':(el, binding) => {
            // 获取element-ui定义好的scroll盒子
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            if(SELECTWRAP_DOM){
              //解除绑定事件
              el.unbindEventListener = () => {
                SELECTWRAP_DOM.removeEventListener("scroll", function () {
                  const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                  if (condition) binding.value();
                });
              }
              //绑定事件
              SELECTWRAP_DOM.addEventListener("scroll", function () {
                /**
                 * scrollHeight 获取元素内容高度(只读)
                 * scrollTop 获取或者设置元素的偏移值,
                 *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
                 * clientHeight 读取元素的可见高度(只读)
                 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
                 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
                 */
                const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (condition) binding.value();
              });
            }
          },
        }
    }	
</script>


// WEBPACK FOOTER //
// src/view/task/taskAdd.vue